/**
 * Generated by orval v7.11.2 🍺
 * Do not edit manually.
 * Catch Member API
 * API for Catch Member Backend
 * OpenAPI spec version: 1.0.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  ProblemDetail,
  QuizletResultsDto
} from '.././model';

import { customFetcher } from '../../../client/customFetcher';




export const quizletControllerGetLatestResults = (
    
 signal?: AbortSignal
) => {
      
      
      return customFetcher<QuizletResultsDto>(
      {url: `/session/me/quizlet/latest-results`, method: 'GET', signal
    },
      );
    }
  

export const getQuizletControllerGetLatestResultsQueryKey = () => {
    return [`/session/me/quizlet/latest-results`] as const;
    }

    
export const getQuizletControllerGetLatestResultsQueryOptions = <TData = Awaited<ReturnType<typeof quizletControllerGetLatestResults>>, TError = ProblemDetail | ProblemDetail>( options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof quizletControllerGetLatestResults>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getQuizletControllerGetLatestResultsQueryKey();

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof quizletControllerGetLatestResults>>> = ({ signal }) => quizletControllerGetLatestResults(signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof quizletControllerGetLatestResults>>, TError, TData> & { queryKey: DataTag<QueryKey, TData> }
}

export type QuizletControllerGetLatestResultsQueryResult = NonNullable<Awaited<ReturnType<typeof quizletControllerGetLatestResults>>>
export type QuizletControllerGetLatestResultsQueryError = ProblemDetail | ProblemDetail


export function useQuizletControllerGetLatestResults<TData = Awaited<ReturnType<typeof quizletControllerGetLatestResults>>, TError = ProblemDetail | ProblemDetail>(
  options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof quizletControllerGetLatestResults>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof quizletControllerGetLatestResults>>,
          TError,
          Awaited<ReturnType<typeof quizletControllerGetLatestResults>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useQuizletControllerGetLatestResults<TData = Awaited<ReturnType<typeof quizletControllerGetLatestResults>>, TError = ProblemDetail | ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof quizletControllerGetLatestResults>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof quizletControllerGetLatestResults>>,
          TError,
          Awaited<ReturnType<typeof quizletControllerGetLatestResults>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }
export function useQuizletControllerGetLatestResults<TData = Awaited<ReturnType<typeof quizletControllerGetLatestResults>>, TError = ProblemDetail | ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof quizletControllerGetLatestResults>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> }

export function useQuizletControllerGetLatestResults<TData = Awaited<ReturnType<typeof quizletControllerGetLatestResults>>, TError = ProblemDetail | ProblemDetail>(
  options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof quizletControllerGetLatestResults>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> } {

  const queryOptions = getQuizletControllerGetLatestResultsQueryOptions(options)

  const query = useQuery(queryOptions , queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



